import { throwError as observableThrowError, Observable } from "rxjs";

import { catchError, map } from "rxjs/operators";
// Angular + external
import { Injectable } from "@angular/core";

//BFX
import { Sound } from "../models/sound.model";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { HttpClient } from "@angular/common/http";
import { NativeNotificationService } from "shared/native-desktop/NativeNotificationService";

@Injectable()
export class BfxSoundsService {
  private _soundsAssetUrl = "../../assets/sounds/sounds.json";
  private sounds: Array<Sound> = []; // stores all sounds
  private soundsMap: Map<string, string> = new Map();
  public primed: boolean = false;
  private primePromise: Promise<boolean>;

  constructor(
    private http: HttpClient,
    private nativeNotificationService: NativeNotificationService,
  ) {}

  public isPrimed(): Promise<boolean> {
    return (this.primePromise = new Promise<boolean>((resolve, reject) => {
      if (this.primed) {
        resolve(true);
      } else {
        this.loadSoundsList().subscribe(
          (sounds) => {
            this.sounds = sounds;
            this.sounds.forEach((sound) => {
              this.soundsMap.set(sound.soundName, sound.path);
            });
            this.primed = true;
            resolve(true);
          },
          (err) => {
            logger.out.error("sounds-s ERROR: loadSounds() = OBSERVABLE ERROR:", err);
          },
        );
      }
    }));
  }

  public getSoundsList(): Promise<Sound[]> {
    try {
      return new Promise((resolve, reject) => {
        resolve(this.sounds);
      });
    } catch (err) {
      return new Promise((resolve, reject) => {
        logger.out.error("sounds-s EXCEPTION: getSoundsList():", err);
        reject("EXCEPTION: SoundsService.getSoundsList(): " + err);
      });
    }
  }

  private loadSoundsList(): Observable<Sound[]> {
    let result = this.http.get(this._soundsAssetUrl).pipe(
      map((response) => <Sound[]>response),
      catchError((error: any) => observableThrowError(error.json().error || "Server error")),
    );
    return result;
  }

  public playSound(name: string, path: string) {
    let audio: any = new Audio();
    try {
      audio.src = path;
      audio.load();
      audio.play();
    } catch (error) {
      logger.out.error("sounds-s EXCEPTION: playSound(): " + error);
    }
  }

  public playSoundById(name: string) {
    if (name === "None") return;
    logger.out.info(`sounds-s calling playSound with id ${name}`);
    this.isPrimed().then(() => {
      let audio: HTMLAudioElement = new Audio();
      try {
        audio.src = this.soundsMap.get(name);
        if (audio.src) {
          audio.load();
          logger.out.info(`sounds-s primed, calling play`);
          const playPromise = audio.play();
          if (playPromise !== undefined) {
            playPromise
              .then((_) => {
                logger.out.info(`sounds-s Playing ${name} successful`);
              })
              .catch((error) => {
                logger.out.error(`sounds-s Error playing ${name}: Error: ${error}`);

                // Create and show the notification
                if (error.name === "NotAllowedError") {
                  const title = "OMS Warning";
                  const text = `Unable to play Alert sound '${name}' - please open OMS UI to ensure OMS alerts are played`;
                  this.nativeNotificationService.openNotification(title, text);
                }
              });
          } else {
            logger.out.error("sounds-s No promise returned from audio play()");
          }
        } else {
          logger.out.error(`sounds-s Cannot find src proerty on audio for '${name}'`);
        }
      } catch (error) {
        logger.out.error("sounds-s EXCEPTION: playSoundById(): " + error);
      }
    });
  }
}
